// extracted by mini-css-extract-plugin
export default {"header":"IG-z","blueBackground":"JG-z","hfImagesComponent":"KG-z","containedImage":"LG-z","headerContainer":"MG-z","headerButton":"NG-z"};